import React, { useContext } from 'react';
import { StyleSheet, View } from 'react-native';
import PropTypes from 'prop-types';
import ComponentContainer from '../common/ComponentContainer';
import ComponentTitle from '../common/ComponentTitle';
import { StyledWebView } from '../common/StyledWebView';
import LayoutContext, { LAYOUTS } from '../../contexts/Layout';

const STYLED_WEB_VIEW_ID = 'TwoColumnWYSIWYG';

const TwoColumnWYSIWYG = ({ leftColumnText, rightColumnText, nodeTypeAlias = 'TwoColumnWYSIWYG', physicalWidth, title, width }) => {
    const { layout } = useContext(LayoutContext);

    const styles = {
        p: {
            ...layout.styleGuide.p1,
            margin: 0
        },
        img: {
            height: '100%',
            margin: 0,
            width: '100%'
        },
        ul: {
            display: 'flex',
            margin: 0,
            marginLeft: layout.styleGuide.margin1
        },
        li: {
            color: '#7f868b',
            fontFamily: 'FrankRuhlLibre',
            fontSize: layout.device.os.equals('web') ? '16pt' : 16,
            lineHeight: layout.device.os.equals('web') ? '20pt' : 20,
            listStyle: 'disc'
        }
    };

    const markerRendererProps = {
        ul: {
            markerBoxStyle: {
                justifyContent: 'center',
                marginVertical: 5,
                paddingRight: 5
            },
            markerTextStyle: {
                color: layout.styleGuide.p1.color,
                fontFamily: layout.styleGuide.p1.fontFamily,
                fontSize: layout.styleGuide.p1.fontSize
            }
        },
        ol: {
            markerBoxStyle: {
                color: layout.styleGuide.p1.color,
                fontFamily: layout.styleGuide.p1.fontFamily,
                fontSize: layout.styleGuide.p1.fontSize,
                marginVertical: 5,
                paddingRight: 5
            },
            markerTextStyle: {
                color: layout.styleGuide.p1.color,
                fontFamily: layout.styleGuide.p1.fontFamily,
                fontSize: layout.styleGuide.p1.fontSize
            }
        }
    };

    const renderOneColumn = () => {
        const oneColumnText = leftColumnText + rightColumnText;

        return (
            <View
                style={StyleSheet.flatten(Styles.oneColumn, { margin: layout.styleGuide.spacer1 })}
                dataSet={{
                    spacerBottom: `StyleGuide.Spacer1(${layout.styleGuide.spacer1})`,
                    spacerLeft: `StyleGuide.Spacer1(${layout.styleGuide.spacer1})`,
                    spacerRight: `StyleGuide.Spacer1(${layout.styleGuide.spacer1})`,
                    spacerTop: `StyleGuide.Spacer1(${layout.styleGuide.spacer1})`
                }}
            >
                <StyledWebView customStyle={styles} html={oneColumnText} nodeId={STYLED_WEB_VIEW_ID} renderersProps={markerRendererProps} width={physicalWidth || width} />
            </View>
        );
    };

    const renderTwoColumn = () => {
        return (
            <View
                style={StyleSheet.flatten(Styles.twoColumnContainer, { marginHorizontal: layout.styleGuide.spacer1 })}
                dataSet={{ spacerLeft: `StyleGuide.Spacer1(${layout.styleGuide.spacer1})`, spacerRight: `StyleGuide.Spacer1(${layout.styleGuide.spacer1})` }}
            >
                {!!leftColumnText && (
                    <View style={Styles.leftColumn}>
                        <StyledWebView
                            customStyle={styles}
                            html={leftColumnText}
                            nodeId={STYLED_WEB_VIEW_ID}
                            renderersProps={markerRendererProps}
                            width={physicalWidth || width}
                        />
                    </View>
                )}
                {!!leftColumnText && !!rightColumnText && <View style={{ width: layout.styleGuide.gutter }} />}
                {!!rightColumnText && (
                    <View style={Styles.rightColumn}>
                        <StyledWebView
                            customStyle={styles}
                            html={rightColumnText}
                            nodeId={STYLED_WEB_VIEW_ID}
                            renderersProps={markerRendererProps}
                            width={physicalWidth || width}
                        />
                    </View>
                )}
            </View>
        );
    };

    return (
        <View
            style={StyleSheet.flatten(Styles.container, { marginBottom: layout.styleGuide.componentSeparator })}
            dataSet={{ umbracoComponentName: nodeTypeAlias, spacerBottom: `StyleGuide.ComponentSeparator(${layout.styleGuide.componentSeparator})` }}
        >
            {!!title && <ComponentTitle title={title} style={{ margin: layout.styleGuide.spacer1 }} />}
            <ComponentContainer style={Styles.contentContainer}>
                {layout.dimensions.width <= 480 || layout.mode !== LAYOUTS.Modern ? renderOneColumn() : renderTwoColumn()}
            </ComponentContainer>
        </View>
    );
};

const Styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center'
    },
    contentContainer: {
        alignItems: 'center',
        marginBottom: 0,
        width: '100%'
    },
    leftColumn: {
        alignItems: 'center',
        flex: 0.5
    },
    oneColumn: {
        alignItems: 'center',
        flex: 1,
        flexWrap: 'wrap'
    },
    rightColumn: {
        flex: 0.5,
        alignItems: 'center'
    },
    twoColumnContainer: {
        flexDirection: 'row',
        flex: 1
    }
});

TwoColumnWYSIWYG.propTypes = {
    title: PropTypes.string,
    leftColumnText: PropTypes.string,
    rightColumnText: PropTypes.string
};

export default TwoColumnWYSIWYG;
